module.exports = __webpack_public_path__ + "img/Googleplay-button0.42da2bb1.png";